import { render, staticRenderFns } from "./StartQuestions.vue?vue&type=template&id=08bdf60b&scoped=true"
import script from "./StartQuestions.vue?vue&type=script&lang=js"
export * from "./StartQuestions.vue?vue&type=script&lang=js"
import style0 from "./StartQuestions.vue?vue&type=style&index=0&id=08bdf60b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bdf60b",
  null
  
)

export default component.exports